/**
 * Centralized constants for creative types
 * Use these constants instead of magic strings throughout the codebase
 */

// Creative types - all uppercase
export const CREATIVE_TYPE = {
  DEFAULT: 'DEFAULT',
  VAST: 'VAST',
  WEB: 'WEB',
} as const;

export type CreativeType = (typeof CREATIVE_TYPE)[keyof typeof CREATIVE_TYPE];

/**
 * Normalize creative type - returns uppercase type if valid, otherwise returns original
 * Only accepts uppercase values from CREATIVE_TYPE constants
 */
export const normalizeCreativeType = (type?: string | null): string => {
  if (!type) return '';

  // Return as-is if it's already a valid uppercase type
  if (
    type === CREATIVE_TYPE.DEFAULT ||
    type === CREATIVE_TYPE.VAST ||
    type === CREATIVE_TYPE.WEB
  ) {
    return type;
  }

  // Return original type if not matching constants
  return type;
};

/**
 * Check if a creative type is a default creative
 * Default creatives include: CREATIVE_TYPE.DEFAULT, CREATIVE_TYPE.VAST, CREATIVE_TYPE.WEB
 */
export const isDefaultCreative = (type?: string | null): boolean => {
  if (!type) return false;
  return (
    type === CREATIVE_TYPE.DEFAULT ||
    type === CREATIVE_TYPE.VAST ||
    type === CREATIVE_TYPE.WEB
  );
};

/**
 * Check if a creative type is a URL-based creative (VAST or WEB)
 */
export const isUrlCreative = (type?: string | null): boolean => {
  if (!type) return false;
  return type === CREATIVE_TYPE.VAST || type === CREATIVE_TYPE.WEB;
};
